import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class Global {
    // LOCAL
    //public static BASE_URL = 'http://hsa-api.hvsfinancial.com.loc/api/';

    // UAT
    //public static BASE_URL = 'https://hsa-api-uat.hvsfinancial.com/api/';

    // HSA PROD
    public static BASE_URL = 'https://hsabank-api.hvsfinancial.com/api/';

    public static GET_TOKEN = 'Token/GetToken';
    public static GET_EXPENSES = 'HSA/GetExpenses';
    public static GET_YOUR_RESULTS = 'HSA/GetYourResults';
    public static GET_LIFE_EXPECTANCY = 'HSA/GetLifeExpectancy';
    public isResult: boolean = false;
    public static GET_HSA_PDF = 'HSA/GetHSAPdf';
    public static GET_EDUCATIONAL_LESSONS = 'Education/GetEducationalLessons'
    public defaultHCCCost: any;
    public originalOOPs: any;
    public originalOverrideOOP: number;
    public isAllocateHC: boolean = false;
    public isGoogleAnalyticsOn: boolean = false;
    
    public activeRoute: any;
    
    public getEduLessonObj: any;
    public selectedEduCategory: any = 0;
    public selectedEduCategoryTitle: string = '';
    public selectedEduCatLesson: any = 0;
    public getCoachTxt: any;
    
    public userName: string;
    public eligibleMedicareRetirementYear: number;
    public yearsUntilEligibleMedicareRetirementYear: number;

    loading;
    orgID = "HSABank";
    //orgID = "Testing";

    public reSizeSliderContainer(scenario) {
        setTimeout(() => {
            if (document.getElementById('slider-container')) {
                let rightContainerHeight = document.getElementById('RightContainer').scrollHeight;
                document.getElementById('slider-container').style.height = `${(rightContainerHeight + 75)}px`;
            }
        }, 500);
    }

    public numberToWords(num: number): string {
        const ones = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
        const teens = ["ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
        const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
      
        if (num < 10) {
          return ones[num];
        } else if (num < 20) {
          return teens[num - 10];
        } else if (num < 100) {
          return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + ones[num % 10] : "");
        } else {
          return "Number out of range";
        }
      }

      public clearEducationSelections(){
        this.selectedEduCategoryTitle = '';
        this.selectedEduCategory = 0;
        this.selectedEduCatLesson = 0;
      }
}
